// src/components/SearchBar.jsx
import React, { useState, useEffect, useCallback } from 'react';
import {
  OutlinedInput,
  InputAdornment,
  IconButton,
  CircularProgress,
  Paper
} from '@mui/material';
import SearchIcon  from '@mui/icons-material/Search';
import ClearIcon   from '@mui/icons-material/Clear';
import debounce    from '../utils/debounce.js';

export default function SearchBar({ onSearch, busy }) {
  const [value, setValue] = useState('');

  /* trigger parent after debounce */
  const debounced = useCallback(
    debounce(v => onSearch(v.trim()), 500),
    [onSearch]
  );

  useEffect(() => debounced(value), [value, debounced]);

  /* clear with Esc or button */
  const handleKey   = e => {
    if (e.key === 'Escape') setValue('');
    if (e.key === 'Enter')  onSearch(value.trim());
  };
  const clearSearch = () => {
    setValue('');
    onSearch('');
  };

  return (
    <Paper
      elevation={0}
      sx={{
        px: 1, py: 0.5,
        borderRadius: 8,
        display: 'flex',
        alignItems: 'center',
        width: { xs: '100%', sm: 320 }
      }}
    >
      <OutlinedInput
        fullWidth
        size="small"
        placeholder="Search updates…"
        value={value}
        onChange={e => setValue(e.target.value)}
        onKeyDown={handleKey}
        startAdornment={
          <InputAdornment position="start">
            <SearchIcon sx={{ color: 'text.secondary' }} />
          </InputAdornment>
        }
        endAdornment={
          <InputAdornment position="end" sx={{ mr: 0.5 }}>
            {busy ? (
              <CircularProgress size={18} />
            ) : value && (
              <IconButton size="small" onClick={clearSearch}>
                <ClearIcon fontSize="small" />
              </IconButton>
            )}
          </InputAdornment>
        }
        sx={{ background: '#fff', borderRadius: 5 }}
      />
    </Paper>
  );
}
